import React from "react";
import useSort from "../../hooks/useSort";

import Table from "../../ui/Table/Table";

import spaceint2 from "../../utils/spaceint2";

const renderSpaceint2 = ({ data, columnInfo }) => (
  <span>{spaceint2(data[columnInfo.accessor])}</span>
);
const renderSummarySpaceint2 = ({ summary, summaryInfo }) => {
  const value = summary[summaryInfo.accessor];
  if (value) {
    return <span>{spaceint2(value)}</span>;
  } else {
    return "-";
  }
};

function getColumns(dateFormatFunc) {
  const columns = [
    {
      title: "Дата",
      accessor: "date",
      className: "table__border-right",
      dataClassName: "table__border-right",
      renderDataCell: ({ data }) => dateFormatFunc(data.date)
    },
    {
      title: "Всего выходов",
      accessor: "clicks",
      className: "table__border-right",
      dataClassName: "table__border-right",
      renderDataCell: renderSpaceint2
    },

    // top
    {
      title: "Выходы с топах",
      accessor: "top_clicks",
      renderDataCell: renderSpaceint2
    },
    {
      title: "Показы в топах",
      accessor: "top_shows",
      renderDataCell: renderSpaceint2
    },
    {
      title: "CTR в топах",
      accessor: "top_ctr",
      className: "table__border-right",
      dataClassName: "table__border-right"
    },

    // inf
    {
      title: "Клики в виджетах",
      accessor: "inf_clicks",
      renderDataCell: renderSpaceint2
    },
    {
      title: "Показы в виджетах",
      accessor: "inf_shows",
      renderDataCell: renderSpaceint2
    },
    {
      title: "CTR виджета",
      accessor: "inf_ctr",
      className: "table__border-right",
      dataClassName: "table__border-right"
    }
  ];

  return columns;
}

const summaryColumns = [
  {
    title: "Итого",
    className: "table__border-right"
  },
  {
    accessor: "clicks",
    className: "table__border-right",
    renderCell: renderSummarySpaceint2
  },
  {
    accessor: "top_clicks",
    renderCell: renderSummarySpaceint2
  },
  {
    accessor: "top_shows",
    renderCell: renderSummarySpaceint2
  },
  {
    accessor: "top_ctr",
    className: "table__border-right"
  },
  {
    accessor: "inf_clicks",
    renderCell: renderSummarySpaceint2
  },
  {
    accessor: "inf_shows",
    renderCell: renderSummarySpaceint2
  },
  {
    accessor: "inf_ctr"
  }
];

const TeaserStatTable = ({ stat, summary, loading, dateFormatFunc }) => {
  const { sortBy, sortOrder, onSortChange } = useSort("date", "desc");
  const columns = getColumns(dateFormatFunc);

  return (
    <Table
      data={stat}
      summary={summary}
      loading={loading}
      columns={columns}
      summaryColumns={summaryColumns}
      className="teaser-stat__stat-table"
      sortBy={sortBy}
      sortOrder={sortOrder}
      onSortChange={onSortChange}
    />
  );
};

TeaserStatTable.defaultProps = {
  dateFormatFunc: date => date
};

export default TeaserStatTable;
